import {
  Box,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  IconButton,
  Stack,
} from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMessage } from "../../../../base/MessageProvider";
import { hideLoadingOverlay, showLoadingOverlay } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  addRecruiterProfile,
  getRecruiterById,
  updateRecruiterProfile,
} from "../../../actions/recruiter";
import { CameraAlt, KeyboardBackspace, Verified } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import ReactSelect from "../../../../components/ControllerComponent/ReactSelect";
import {
  basicProfilecategory,
  contactPrivacyOptions,
  genderOptions,
  nationalityOptions,
} from "../../../../constants";
import ReactiveDatePickerField from "../../../../components/ControllerComponent/ReactDatePicker";
import {
  validationAddRecruiterSchema,
  validationUpdateRecruiterSchema,
} from "./validations";
import { getProfileCategoryList } from "../../../actions/profileCategory";
import ReactTextInput from "../../../../components/ControllerComponent/ReactTextInput";
import ReactTelInput from "../../../../components/ControllerComponent/ReactTelInput";
import ReactLocationInput from "../../../../components/ControllerComponent/ReactLocationInput";
import { useState } from "react";
import ImageUploadOptions from "../../../../components/ImageUploadOptions";
import OAuth from "../../OAuth";
import { uploadProfilePicture } from "../../../actions/auth";

const DirectorProfileForm = (props) => {
  const { open, onRefresh, navigation, addNew = false, onClose } = props;
  const [profileUploaderOpen, setProfileUploaderOpen] = useState(false);
  const [kycUploaderOpen, setKycUploaderOpen] = useState(false);

  const alert = useMessage();
  const dispatch = useDispatch();
  const selectedRecruiter = useSelector(
    (state) => state.recruiterReducer?.selectedRecruiter
  );
  const locationList =
    useSelector((state) => state.generalReducer?.locationList) ?? [];
  const experienceYearList =
    useSelector((state) => state.generalReducer?.experienceYearList) ?? [];
  const profileCategoryList =
    useSelector((state) => state.profileCategoryReducer?.profileCategoryList) ??
    [];
  const recruiterExperienceCategoryList =
    useSelector(
      (state) => state.generalReducer?.recruiterExperienceCategoryList
    ) ?? [];

  const profileCategoryOptions = useMemo(
    () =>
      profileCategoryList.map((item) => ({ label: item.name, value: item.id })),
    [profileCategoryList]
  );

  const experienceYearOptions = useMemo(
    () => experienceYearList.map((item) => ({ label: item, value: item })),
    [experienceYearList]
  );

  const experienceCategoriesOption = useMemo(
    () =>
      recruiterExperienceCategoryList.map((item) => ({
        label: item,
        value: item,
      })),
    [recruiterExperienceCategoryList]
  );

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(
      addNew ? validationAddRecruiterSchema : validationUpdateRecruiterSchema
    ),
  });

  const selectedCategory = watch("profileCategoryId");
  // const isAvailableInIndia = watch('ain');
  const isAgency = selectedCategory
    ? selectedCategory !== basicProfilecategory.CASTING_DIRECTOR &&
      selectedCategory !== basicProfilecategory.COORDINATOR
    : false;

  const profilePic = watch("profileImage")
    ? URL.createObjectURL(watch("profileImage"))
    : null;

  console.log(watch("profileImage"), profilePic);

  useEffect(() => {
    setValue("profileImage", null);
    clearErrors();
    reset();
  }, [open]);

  useEffect(() => {
    clearErrors();
    reset();
    if (open && navigation.route === "DirectorProfileForm") {
      setValue("userId", selectedRecruiter?.userId ?? "");
      setValue("firstName", selectedRecruiter?.firstName ?? "");
      setValue("lastName", selectedRecruiter?.lastName ?? "");
      setValue(
        "profileCategoryId",
        selectedRecruiter?.userProfile?.profileCategory?.id ?? ""
      );
      setValue(
        "experienceCategory",
        selectedRecruiter?.userProfile?.experienceCategory
      );
      setValue(
        "experienceYears",
        selectedRecruiter?.userProfile?.experienceYears
      );
      setValue("gender", selectedRecruiter?.userProfile?.gender ?? "");
      setValue(
        "dob",
        selectedRecruiter?.userProfile?.dob
          ? new Date(selectedRecruiter?.userProfile?.dob)
          : null
      );
      setValue(
        "mobileNo",
        selectedRecruiter?.mobileNo
          ? `${selectedRecruiter.dialCode}${selectedRecruiter?.mobileNo}`
          : ""
      );
      setValue("email", selectedRecruiter?.email ?? "");
      setValue("contactVisibility", selectedRecruiter?.contactVisibility ?? "");
      setValue("bio", selectedRecruiter?.userProfile?.bio ?? "");
      setValue(
        "businessMobileNo",
        selectedRecruiter?.userProfile?.businessMobileNo
          ? `${selectedRecruiter?.dialCode}${selectedRecruiter?.userProfile?.businessMobileNo}`
          : ""
      );
      setValue(
        "businessEmail",
        selectedRecruiter?.userProfile?.businessEmail ?? ""
      );
      setValue("location", selectedRecruiter?.userProfile?.location ?? "");
      setValue(
        "companyName",
        selectedRecruiter?.userProfile?.companyName ?? ""
      );
      setValue(
        "nationality",
        selectedRecruiter?.userProfile?.nationality ?? ""
      );
    }
  }, [selectedRecruiter, navigation.route, open]);

  useEffect(() => {
    if (addNew) {
      setValue("dob", null);
      setValue("companyName", "");
      setValue("mobileNo", "");
      setValue("email", "");
      setValue("location", "");
    }
  }, [selectedCategory]);

  const addSuccessCallBack = (res) => {
    const profileImage = watch("profileImage");
    if (profileImage && res?.data?.[0]?.userId) {
      const profilePicFormData = new FormData();
      profilePicFormData.append("file", profileImage);
      profilePicFormData.append("profileId", res?.data?.[0]?.userId);
      dispatch(
        uploadProfilePicture(
          profilePicFormData,
          (res) => {
            alert.showSuccess("Successfully added");
            onRefresh();
            onClose();
            hideLoadingOverlay();
          },
          (error) => {
            alert.showError(error?.message ?? "Something went wrong");
            hideLoadingOverlay();
          }
        )
      );
    } else {
      alert.showSuccess(res?.message ?? "Successfully added");
      onRefresh();
      onClose();
      hideLoadingOverlay();
    }
  };

  const updateSuccessCallBack = (res) => {
    alert.showSuccess(res?.message ?? "Successfully updated");
    dispatch(
      getRecruiterById(
        { profileId: selectedRecruiter.userId },
        () => {},
        (error) => {}
      )
    );
    onRefresh();
    navigation?.goBack();
  };

  const addHandler = async (data) => {
    showLoadingOverlay();
    await dispatch(
      addRecruiterProfile(data, addSuccessCallBack, (error) => {
        alert.showError(error?.message ?? "Something went wrong", {
          timeout: 10000,
        });
      })
    );
    hideLoadingOverlay();
  };

  const updateHandler = async (data) => {
    showLoadingOverlay();
    await dispatch(
      updateRecruiterProfile(data, updateSuccessCallBack, (error) => {
        alert.showError(error?.message ?? "Something went wrong");
      })
    );
    hideLoadingOverlay();
  };

  const onProfileUpload = () => {
    setProfileUploaderOpen(true);
  };
  const onKycUpload = () => {
    setKycUploaderOpen(true);
  };

  const handleProfilePic = (image) => {
    const file = image[0];
    setValue("profileImage", file);
  };

  const handleKycPic = (image) => {
    const file = image[0];
    const imageUrl = URL.createObjectURL(file);

    console.log("Image URL: ", imageUrl);
    const formData = new FormData();
    formData.append("file", image[0]);
    // dispatch(
    //   uploadProfilePicture(
    //     formData,
    //     (res) => {
    //       alert.showSuccess(res?.message);
    //       refreshData();
    //       onRefresh();
    //     },
    //     (error) => {
    //       alert.showError(error?.message ?? "Something went wrong!!");
    //     }
    //   )
    // );
  };

  return (
    <Box className="h-full w-full flex flex-col justify-between pb-7 overflow-y-auto">
      <div>
        <div className="flex items-center py-5 px-4">
          {addNew ? null : (
            <IconButton onClick={navigation?.goBack}>
              <KeyboardBackspace />
            </IconButton>
          )}
          <h2 className="w-full text-center font-['Poppins-Semibold'] leading-[30px] text-[14px] ">
            {addNew ? "CREATE" : "EDIT"} DIRECTOR
          </h2>
        </div>

        {addNew && (
          <>
            <div className="flex justify-center my-3 ">
              <div
                className={`flex justify-center items-center h-full space-x-6`}
              >
                <FormControl
                  error={errors?.profileImage?.message !== null}
                  fullWidth
                >
                  <div className="relative flex flex-col items-center">
                    <h3 className="mb-2">Profile Picture</h3>
                    <img
                      className="rounded-full w-28 h-28 border-[1px] border-gray-200"
                      src={
                        profilePic
                          ? profilePic
                          : require("../../../../assets/images/user-img.png")
                      }
                      alt="Profile"
                    />
                    <IconButton
                      onClick={onProfileUpload}
                      className="bg-[#2F80ED] text-white absolute bottom-0 right-0 p-2 transform translate-x-1/4 translate-y-1/4"
                    >
                      <CameraAlt className="text-lg" />
                    </IconButton>
                  </div>
                  {errors?.profileImage?.message && (
                    <FormHelperText
                      className="mt-2 font-['Poppins-Regular']"
                      id="component-error-text"
                    >
                      {errors?.profileImage?.message}
                    </FormHelperText>
                  )}
                </FormControl>

                {/* <div className="relative flex flex-col items-center">
                  <h3 className="mb-2">KYC Picture</h3>
                  <OAuth
                    altSrc={require("../../../../assets/images/user-img.png")}
                    component={
                      <img
                        className="rounded-full w-28 h-28 border-[1px] border-gray-200"
                        src={kycImageUrl}
                        // onClick={() =>
                        //   handleImageClick(selectedArtist?.kycMedia?.url)
                        // }
                        alt="KYC Picture"
                      />
                    }
                  />
                  <IconButton
                    onClick={onKycUpload}
                    className="bg-[#2F80ED] text-white absolute bottom-0 right-0 p-2 transform translate-x-1/4 translate-y-1/4"
                  >
                    <CameraAlt className="text-lg" />
                  </IconButton>
                </div> */}
              </div>
            </div>
            <Divider />
          </>
        )}

        <Divider />
        <Stack px={2} py={4} spacing={2}>
          <Stack direction={"row"} spacing={1}>
            <ReactTextInput
              hookFormControl={control}
              label="First Name"
              varName="firstName"
              key={"firstName"}
              required
              // readOnly={!addNew}
              errorMessage={errors?.firstName?.message}
            />
            <ReactTextInput
              hookFormControl={control}
              label="Last Name"
              varName="lastName"
              key={"lastName"}
              required
              // readOnly={!addNew}
              errorMessage={errors?.lastName?.message}
            />
          </Stack>
          <ReactSelect
            hookFormControl={control}
            label="Profile Category"
            varName="profileCategoryId"
            required
            key={"profileCategoryId"}
            options={profileCategoryOptions}
            // readOnly={!addNew}
            errorMessage={errors?.profileCategoryId?.message}
          />
          <ReactiveDatePickerField
            hookFormControl={control}
            label={isAgency ? "Company Establishment Date" : "Date of Birth"}
            varName={"dob"}
            errorMessage={errors?.dob?.message}
            maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
            // readOnly={!addNew}
          />
          {isAgency && (
            <ReactTextInput
              hookFormControl={control}
              label="Company Name"
              varName="companyName"
              key={"companyName"}
              errorMessage={errors?.companyName?.message}
            />
          )}
          <ReactSelect
            hookFormControl={control}
            label="Gender"
            required
            varName="gender"
            key={"gender"}
            options={genderOptions}
            errorMessage={errors?.gender?.message}
          />
          {addNew ? (
            <>
              <ReactTelInput
                hookFormControl={control}
                label={isAgency ? "Company Mobile No" : "Mobile No"}
                varName="mobileNo"
                key={"mobileNo"}
                errorMessage={errors?.mobileNo?.message}
              />
              <ReactTextInput
                hookFormControl={control}
                label={isAgency ? "Company Email" : "Email"}
                varName="email"
                key={"email"}
                datatype="email"
                errorMessage={errors?.email?.message}
              />
            </>
          ) : null}

          <ReactSelect
            hookFormControl={control}
            label="Contact Privacy"
            varName="contactVisibility"
            key={"contactVisibility"}
            withSelect={false}
            options={contactPrivacyOptions}
            errorMessage={errors?.contactVisibility?.message}
          />

          <ReactLocationInput
            placeholder="Eg. Mumbai, Maharashtra"
            label={isAgency ? "Company Location" : "Based In"}
            hookFormControl={control}
            varName="location"
            errorMessage={errors?.location?.message}
            options={locationList}
          />

          <ReactSelect
            hookFormControl={control}
            label={isAgency ? "Your Work Experience" : "Work Experience"}
            required={addNew}
            varName="experienceYears"
            key={"experienceYears"}
            withSelect={false}
            options={experienceYearOptions}
            errorMessage={errors?.experienceYears?.message}
          />

          <ReactSelect
            hookFormControl={control}
            label="Experience Category"
            varName="experienceCategory"
            required={addNew}
            key={"experienceCategory"}
            withSelect={false}
            options={experienceCategoriesOption}
            errorMessage={errors?.experienceCategory?.message}
          />

          <ReactTextInput
            hookFormControl={control}
            label={"Bio"}
            varName="bio"
            key={"bio"}
            rows={3}
            maxLength={600}
            isMultiLine
            errorMessage={errors?.bio?.message}
          />
          <ReactTelInput
            hookFormControl={control}
            label="Business Mobile No"
            varName="businessMobileNo"
            key={"businessMobileNo"}
            errorMessage={errors?.businessMobileNo?.message}
          />
          <ReactTextInput
            hookFormControl={control}
            label="Business Email"
            varName="businessEmail"
            key={"businessEmail"}
            datatype="email"
            errorMessage={errors?.businessEmail?.message}
          />
          <ReactSelect
            hookFormControl={control}
            label="Nationality"
            varName="nationality"
            key={"nationality"}
            options={nationalityOptions.map(({ label }) => ({
              label,
              value: label,
            }))}
            errorMessage={errors?.nationality?.message}
          />
        </Stack>
        <Divider />
        <div className="flex flex-col justify-between items-center gap-2 py-5 px-5">
          <Button
            onClick={handleSubmit(addNew ? addHandler : updateHandler)}
            variant="contained"
            className="w-full font-['Poppins-Medium'] normal-case text-[14px] text-white"
          >
            {!addNew ? "UPDATE" : "ADD"}
          </Button>
        </div>
      </div>

      <ImageUploadOptions
        open={profileUploaderOpen}
        hideCamera={true}
        onClose={setProfileUploaderOpen?.bind(null, false)}
        onSubmit={handleProfilePic}
      />
      <ImageUploadOptions
        open={kycUploaderOpen}
        hideCamera={true}
        onClose={setKycUploaderOpen?.bind(null, false)}
        onSubmit={handleKycPic}
      />
    </Box>
  );
};

export default DirectorProfileForm;
